import getFloat from './getFloat';

const getFilterValue = function getFilterValue(filter) {
    const toiAttributesInSeconds = [
        'evTimeOnIce',
        'evTimeOnIcePerGame',
        'evenStrengthTimeOnIcePerGame',
        'otTimeOnIce',
        'otTimeOnIcePerOtGame',
        'penaltyMinutesPerTimeOnIce',
        'penaltySecondsPerGame',
        'pkTimeOnIcePerGame',
        'powerPlayTimeOnIcePerGame',
        'ppTimeOnIce',
        'ppTimeOnIcePctPerGame',
        'ppTimeOnIcePerGame',
        'shTimeOnIce',
        'shTimeOnIcePctPerGame',
        'shTimeOnIcePerGame',
        'shortHandedTimeOnIcePerGame',
        'timeOnIce',
        'timeOnIce3v4',
        'timeOnIce3v5',
        'timeOnIce4v3',
        'timeOnIce4v5',
        'timeOnIce5v3',
        'timeOnIce5v4',
        'timeOnIcePerGame',
        'timeOnIcePerGame5v5',
        'timeOnIcePerShift',
        'timeOnIcePp',
        'timeOnIceShorthanded',
    ];

    const pctgAttributesAsRatios = [
        'careerSavePct',
        'careerShootoutSavePct',
        'careerShootoutShootingPct',
        'completeGamePct',
        'defensiveZoneFaceoffPct',
        'evFaceoffPct',
        'evSavePct',
        'evenStrengthGoalsForPct',
        'faceoffPct5v5',
        'faceoffWinPct',
        'gamesRelievedSavePct',
        'gamesStartedSavePct',
        'goalsForPct',
        'goalsPct',
        'neutralZoneFaceoffPct',
        'offensiveZoneFaceoffPct',
        'offensiveZoneStartPct5v5',
        'onIceShootingPct',
        'onIceShootingPct5v5',
        'overallPenaltyKillPct',
        'overallPowerPlayPct',
        'penaltyKillNetPct',
        'penaltyKillPct',
        'penaltyKillPct3v4',
        'penaltyKillPct3v5',
        'penaltyKillPct4v5',
        'penaltyMinutesPerTimeOnIce',
        'penaltyShotSavePct',
        'penaltyShotShootingPct',
        'pointPct',
        'powerPlayNetPct',
        'powerPlayPct',
        'powerPlayPct4v3',
        'powerPlayPct5v3',
        'powerPlayPct5v4',
        'ppFaceoffPct',
        'ppSavePct',
        'ppShootingPct',
        'ppTimeOnIcePctPerGame',
        'qualityStartsPct',
        'satPct',
        'satPctAhead',
        'satPctBehind',
        'satPctClose',
        'satPctTied',
        'satPercentage',
        'satPercentageAhead',
        'satPercentageBehind',
        'satPercentageClose',
        'satPercentageTied',
        'satRelative',
        'satRelative5v5',
        'savePct',
        'savePct5v5',
        'savePctDaysRest0',
        'savePctDaysRest1',
        'savePctDaysRest2',
        'savePctDaysRest3',
        'savePctDaysRest4Plus',
        'shFaceoffPct',
        'shSavePct',
        'shShootingPct',
        'shTimeOnIcePctPerGame',
        'skaterSavePct5v5',
        'skaterShootingPlusSavePct5v5',
        'shootingPct',
        'shootingPct5v5',
        'shootingPctBackhand',
        'shootingPctBat',
        'shootingPctBetweenLegs',
        'shootingPctCradle',
        'shootingPctDeflected',
        'shootingPctPoke',
        'shootingPctSlap',
        'shootingPctSnap',
        'shootingPctTipIn',
        'shootingPctWrapAround',
        'shootingPctWrist',
        'shootingPlusSavePct5v5',
        'shootoutSavePct',
        'shootoutShootingPct',
        'shootoutWinPct',
        'usatPct',
        'usatPctAhead',
        'usatPctBehind',
        'usatPctClose',
        'usatPctTied',
        'usatPercentage',
        'usatPercentageAhead',
        'usatPercentageBehind',
        'usatPercentageClose',
        'usatPrecentageClose',
        'usatPercentageTied',
        'usatRelative',
        'winPctLeadPeriod1',
        'winPctLeadPeriod2',
        'winPctOneGoalGames',
        'winPctScoringFirst',
        'winPctThreeGoalGames',
        'winPctTrailPeriod1',
        'winPctTrailPeriod2',
        'winPctTrailingFirst',
        'winPctTwoGoalGames',
        'zoneStartPct',
        'zoneStartPct5v5',
    ];

    let { value } = filter;

    if (toiAttributesInSeconds.indexOf(filter.measure) !== -1) {
        value = parseFloat(filter.value) * 60;
    } else if (pctgAttributesAsRatios.indexOf(filter.measure) !== -1) {
        value = getFloat(value);
    }

    return value;
};

export default getFilterValue;
